  <mat-card>
      <mat-card-header>
          <mat-card-title>Ticket per Officina ({{nomestato}})</mat-card-title>
      </mat-card-header>
      <mat-card-content class="content">
        <table>
          <tr [hidden]="commessa.Codice===0">
            <td>
               <mat-form-field [style.display]="getConfigurazione().Persona" appearance="fill" style="padding-right: 10px">
                 <mat-label class="text-sm">Seleziona persona</mat-label>
                 <mat-select [(ngModel)]="selectedValuePersona" (selectionChange)="manageChangePersona()" class="example-full-width">
                   <mat-option></mat-option>
                   <mat-option *ngFor="let persona of persone" [value]="persona.Codice" required>
                     {{persona.Nome}} {{persona.Cognome}}
                   </mat-option>
                 </mat-select>
               </mat-form-field>

              <button mat-raised-button  color="primary" (click)="assegna()" [hidden]="personeAssegnate.length>0 || commessa.Codice===0" [disabled]="persona.Codice===0 || persona===undefined">Assegna a persona</button>
              <button mat-raised-button  color="primary" (click)="disassegna()" [hidden]="personeAssegnate.length===0 || commessa.Codice===0" [disabled]="persona.Codice===0 || persona===undefined">Diassegna da persona</button>

            </td>
          </tr>
          <tr [hidden]="commessa.Codice>0">
            <td>
              <mat-label style="padding-left:10px; font-family: Roboto; font-weight: bold" class="text-sm">Sarà possibile assegnare una commessa soltanto dopo averne salvata una!</mat-label>
            </td>
          </tr>
        </table>
        <form [formGroup]="registerForm" (ngSubmit)="save()">

        <table>
          <tr>
            <td>
              <mat-form-field [style.display]="getConfigurazione().Numerocommessa" class="text-sm">
                <mat-label class="text-sm">Numero Commessa</mat-label>
                <input [readonly]="true"  matInput placeholder="Numero Commessa" formControlName="Numerocommessa" name="Numerocommessa" readOnly="true">
              </mat-form-field>
            </td>
            <td>
               <mat-form-field [style.display]="getConfigurazione().Nometipocommessa" appearance="fill" style="padding-right: 10px">
                 <mat-label class="text-sm">Tipo commessa</mat-label>
                 <mat-select formControlName="selectedValueTipocommessa" name="tipocommessa" class="text-sm">
                   <mat-option></mat-option>
                   <mat-option *ngFor="let tipocommessa of tipicommessa" [value]="tipocommessa.Nome" required>
                     {{tipocommessa.Nome}}
                   </mat-option>
                 </mat-select>
               </mat-form-field>
             </td>
             <td>
               <mat-form-field [style.display]="getConfigurazione().Dataingresso" style="minwidth=800px; width=100%">
                         <mat-label class="text-sm">Data Accettazione</mat-label>
                         <input matInput [matDatepicker]="startpicker"
                           placeholder="Data Accettazione"
                           formControlName="Dataingresso"
                           name="Dataingresso" required>
                         <mat-datepicker-toggle matIconSuffix [for]="startpicker"></mat-datepicker-toggle>
                         <mat-datepicker #startpicker startView="month" ></mat-datepicker>
               </mat-form-field>
             </td>
             <td>
               <mat-form-field [style.display]="getConfigurazione().Datafine" class="text-sm">
                         <mat-label class="text-sm">Data Fine Lavori</mat-label>
                         <input matInput [matDatepicker]="endpicker"
                           placeholder="Data Fine Lavori"
                           formControlName="Datafine"
                           name="Datafine">
                         <mat-datepicker-toggle matIconSuffix [for]="endpicker"></mat-datepicker-toggle>
                         <mat-datepicker #endpicker startView="month" ></mat-datepicker>
               </mat-form-field>
             </td>

          </tr>
        </table>

            <!--
            <td>
              <mat-form-field style="padding-right:10px" class="text-sm">
                 <mat-label class="text-sm" class="text-sm">Cerca cliente...</mat-label>
                 <input matInput [disabled]="commessa!=undefined && commessa.Codice!=0" name="filtroCliente" (keyup)="onFiltroClienteKeyup($event)" class="text-sm">
              </mat-form-field>
            </td>

            <td>
               <mat-form-field [style.display]="getConfigurazione().Nomecliente" class="text-sm">
                 <mat-label class="text-sm">Selezione Cliente</mat-label>
                 <mat-select formControlName="selectedValueAzienda" [disabled]="commessa!=undefined && commessa.Codice!=0" name="azienda" class="text-sm">
                   <mat-option>
                     ""
                   </mat-option>
                   <mat-option *ngFor="let azienda of aziende" [value]="azienda.Codice" required>
                     {{azienda.Nome}}
                   </mat-option>
                 </mat-select>
               </mat-form-field>
            </td>
            -->

            <!--  [formControl]="aziendeCtrl" -->
            <!-- *ngFor="let azienda of aziendefiltrate | async" -->

              <mat-form-field style="width: 100%">
                <input
                  matInput
                  placeholder="Aziende"
                  aria-label="Aziende"
                  [matAutocomplete]="auto"
                  (keyup)="onFiltroAziendaKeyup($event)"
                  formControlName="selectedValueAzienda"
                  required
                  [readonly]="commessa!=undefined && commessa.Codice!=0"
                />
                <mat-autocomplete #auto="matAutocomplete" (optionSelected) ="selectedAziendaOption()">
                  <mat-option
                    *ngFor="let azienda of aziendefiltrate | async"
                    [value]="azienda.Nome"
                    [disabled]="commessa!=undefined && commessa.Codice!=0">
                    <span>{{ azienda.Nome }}</span>
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

        <table>
          <tr>
            <td>
              <mat-label style="padding-left:10px; font-family: Roboto; font-weight: bold" class="text-sm">Veicolo</mat-label>
            </td>
            <td>
              <mat-label style="padding-left:10px; font-family: Roboto; font-weight: bold" class="text-sm">Frigo</mat-label>
            </td>
          </tr>
          <tr>
            <td>
              <mat-form-field [style.display]="getConfigurazione().Marcaveicolo" class="example-full-width">
                        <mat-label class="text-sm">Marca</mat-label>
                        <input matInput placeholder="Marca" formControlName="Marcaveicolo" name="Marcaveicolo" >
              </mat-form-field>

              <mat-form-field [style.display]="getConfigurazione().Modelloveicolo" class="example-full-width">
                        <mat-label class="text-sm">Modello</mat-label>
                        <input matInput placeholder="Modello" formControlName="Modelloveicolo" name="Modelloveicolo" >
              </mat-form-field>
<!--
              <mat-form-field [style.display]="getConfigurazione().Targaveicolo" class="example-full-width">
                      <mat-label class="text-sm">Targa</mat-label>
                      <input matInput placeholder="Targa" formControlName="Targaveicolo" name="Targaveicolo" >
              </mat-form-field>
-->
              <mat-form-field [style.display]="getConfigurazione().Targaveicolo" class="example-full-width">
                <mat-label class="text-sm">Targa</mat-label>
                <input
                  matInput
                  [matAutocomplete]="autotarga"
                  (keyup)="onFiltroTargaKeyup($event)"
                  formControlName="Targaveicolo"
                />
                <mat-autocomplete #autotarga="matAutocomplete">
                  <mat-option
                    *ngFor="let targa of targhefiltrate | async"
                    [value]="targa">
                    <span>{{ targa }}</span>
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

<!--
              <mat-form-field [style.display]="getConfigurazione().Telaioveicolo" class="example-full-width">
                        <mat-label class="text-sm">Telaio</mat-label>
                        <input matInput placeholder="Telaio" formControlName="Telaioveicolo" name="Telaioveicolo" >
              </mat-form-field>
-->
              <mat-form-field [style.display]="getConfigurazione().Telaioveicolo" class="example-full-width">
                <mat-label class="text-sm">Telaio</mat-label>
                <input
                  matInput
                  [matAutocomplete]="autotelaio"
                  (keyup)="onFiltroTelaioKeyup($event)"
                  formControlName="Telaioveicolo"
                />
                <mat-autocomplete #autotelaio="matAutocomplete">
                  <mat-option
                    *ngFor="let telaio of telaifiltrati | async"
                    [value]="telaio">
                    <span>{{ telaio }}</span>
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

            </td>
            <td>
              <mat-form-field [style.display]="getConfigurazione().Marcafrigo" class="example-full-width">
                        <mat-label class="text-sm">Marca</mat-label>
                        <input matInput placeholder="Marca" formControlName="Marcafrigo" name="Marcafrigo" >
              </mat-form-field>

              <mat-form-field [style.display]="getConfigurazione().Matricolafrigo" class="example-full-width">
                        <mat-label class="text-sm">Matricola Frigo</mat-label>
                        <input matInput placeholder="Matricola" formControlName="Matricolafrigo" name="Matricolafrigo" >
              </mat-form-field>

              <mat-form-field [style.display]="getConfigurazione().Modellofrigo" class="example-full-width">
                        <mat-label class="text-sm">Modello Frigo</mat-label>
                        <input matInput placeholder="Modello" formControlName="Modellofrigo" name="Modellofrigo" >
              </mat-form-field>

              <mat-form-field [style.display]="getConfigurazione().Annofabbricazionefrigo" class="example-full-width">
                        <mat-label class="text-sm">Anno di Fabbricazione</mat-label>
                        <input matInput placeholder="Anno di Fabbricazione" formControlName="Annofabbricazionefrigo" name="Annofabbricazionefrigo" >
              </mat-form-field>
            </td>
          </tr>
          <tr>
            <td>
              <mat-label style="padding-left:10px; font-family: Roboto; font-weight: bold" class="text-sm">Anomalie riferite dal cliente</mat-label>
            </td>
            <td>
              <mat-label style="padding-left:10px; font-family: Roboto; font-weight: bold" class="text-sm">Diagnosi officina</mat-label>
            </td>
          </tr>
          <tr>
            <td>
              <mat-form-field [style.display]="getConfigurazione().Note" style="height:120px" class="example-full-width">

                        <textarea matInput
                            cdkTextareaAutosize placeholder="..." formControlName="Note" name="Note"
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="1"
                            cdkAutosizeMaxRows="5"></textarea>
              </mat-form-field>
            </td>
            <td>
              <mat-form-field [style.display]="getConfigurazione().Noteofficina" style="height:120px" class="example-full-width">

                        <textarea matInput
                            cdkTextareaAutosize placeholder="..." formControlName="Noteofficina" name="Noteofficina"
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="1"
                            cdkAutosizeMaxRows="5"></textarea>
              </mat-form-field>
              
            </td>
          </tr>
        </table>
        <table class="example-full-width">
          <tr>
            <td>
              <mat-form-field [style.display]="getConfigurazione().Tot" class="example-full-width">
                        <mat-label class="text-sm">Tot</mat-label>
                        <input matInput placeholder="Tot" formControlName="Tot" name="Tot" >
              </mat-form-field>
            </td>
    
            <td>
              <mat-form-field [style.display]="getConfigurazione().Eng" class="example-full-width">
                        <mat-label class="text-sm">Eng</mat-label>
                        <input matInput placeholder="Eng" formControlName="Eng" name="Eng" >
              </mat-form-field>
            </td>
        
            <td>
              <mat-form-field [style.display]="getConfigurazione().Ele" class="example-full-width">
                        <mat-label class="text-sm">Ele</mat-label>
                        <input matInput placeholder="Ele" formControlName="Ele" name="Ele" >
              </mat-form-field>
            </td>
          </tr>
        </table>


          <mat-form-field [style.display]="getConfigurazione().Codice" class="example-full-width">
                    <mat-label class="text-sm">Codice</mat-label>
                    <input matInput placeholder="Codice" formControlName="Codice" name="Codice" >
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Codiceazienda" class="example-full-width">
                    <mat-label class="text-sm">Codiceazienda</mat-label>
                    <input matInput placeholder="Codiceazienda" formControlName="Codiceazienda" name="Codiceazienda" required>
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Codicetipocommessa" class="example-full-width">
                    <mat-label class="text-sm">Codicetipocommessa</mat-label>
                    <input matInput placeholder="Codicetipocommessa" formControlName="Codicetipocommessa" name="Codicetipocommessa" >
          </mat-form-field>

        </form>

        <table>
          <tr>
            <td>
              <mat-label style="width:70%; padding-left:10px; font-family: Roboto; font-weight: bold" class="text-sm">Lavori effettuati</mat-label>
            </td>
          </tr>
        </table>


        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

            <ng-container hidden matColumnDef="Codice">
                <th mat-header-cell *matHeaderCellDef>Codice</th>
                <td mat-cell *matCellDef="let lavorazione"> {{lavorazione.Codice}} </td>
            </ng-container>

            <ng-container matColumnDef="Nome">
                <th mat-header-cell *matHeaderCellDef>Nome</th>
                <td mat-cell *matCellDef="let lavorazione"> {{lavorazione.Nome}} </td>
            </ng-container>

            <ng-container matColumnDef="Stato">
                <th mat-header-cell *matHeaderCellDef>Stato</th>
                <td mat-cell *matCellDef="let lavorazione"> {{lavorazione.Statolavorazione.Nome}} </td>
            </ng-container>

            <ng-container matColumnDef="Importo">
                <th mat-header-cell *matHeaderCellDef>Importo</th>
                <td mat-cell *matCellDef="let lavorazione"> {{lavorazione.Importo}} </td>
            </ng-container>

            <ng-container matColumnDef="Sconto">
              <th mat-header-cell *matHeaderCellDef>Sconto %</th>
              <td mat-cell *matCellDef="let lavorazione">
                <ng-container *ngIf="!isReadonlyLavorazione(lavorazione)">
                  <input matInput value="{{lavorazione.Sconto}}" (keyup)="onScontoKeyup(lavorazione, $event)">
                </ng-container>
                <ng-container *ngIf="isReadonlyLavorazione(lavorazione)">
                  {{lavorazione.Sconto}}
                </ng-container>
              </td>
            </ng-container>

            <ng-container matColumnDef="Subtotale">
                <th mat-header-cell *matHeaderCellDef>Subtotale</th>
                <td mat-cell *matCellDef="let lavorazione"> {{lavorazione.Subtotale}} </td>
            </ng-container>

            <ng-container matColumnDef="save">
                <th mat-header-cell *matHeaderCellDef> Salva </th>
                <td mat-cell *matCellDef="let lavorazione">
                  <ng-container *ngIf="!isReadonlyLavorazione(lavorazione)">
                    <mat-icon color="primary" (click)="saveLavorazione(lavorazione)">save</mat-icon>
                  </ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="articolilavorazione">
                <th mat-header-cell *matHeaderCellDef> Materiali </th>
                <td mat-cell *matCellDef="let lavorazione">
                  <ng-container *ngIf="!isReadonlyLavorazione(lavorazione)">
                      <mat-icon color="primary" (click)="articolilavorazione(lavorazione)">storage</mat-icon>
                  </ng-container>
                </td>
            </ng-container>


              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
<br>
          <table>
            <tr>
              <td>
                <mat-label style="width:70%; padding-left:10px; font-family: Roboto; font-weight: bold" class="text-sm">Totale: {{importotale}}</mat-label>
              </td>
            </tr>
          </table>

      </mat-card-content>

      <mat-card-actions>
        <table>
          <tr>
            <td>
              <button mat-raised-button  color="primary" (click)="save()">Salva</button>
            </td>
            <td>
              <button mat-raised-button  color="primary" (click)="cancel()">Cancella</button>
            </td>
          </tr>
        </table>
      </mat-card-actions>

  </mat-card>
